import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import AlertModal from 'web/components/AlertModal';
import AddAPhotoOutlinedIcon from '@material-ui/icons/AddAPhotoOutlined';
import {
  profileImage, imageShow
} from 'redux/actions/profile';

const ProfilePicture = ({ name, props, profileImagePath, Picture, ProfileName, CompanyName, pageType }) => {
  const [userImage, setUserImage] = useState();
  let history = useHistory();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  let setProfilePic;
  if (profileImagePath !== undefined && profileImagePath !== null && profileImagePath !== "") {
    setProfilePic = process.env.REACT_APP_API_URL + '/user/image/' + profileImagePath
  } else {
    setProfilePic = Picture
  }
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const getProfilePic = () => {
    if (name !== "profileImgCommunity")
      document.getElementById('getFile').click();
  };

  const onImageChange = (e) => {
    e.preventDefault();
    const maxFileSize = 10 * 1024 * 1024;
    let acceptFiles = "image/png,image/jpeg";
    let errorMsg = "File type must be .PNG, .JPG";
    const fileTypes = acceptFiles.split(',');
    let files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      if (file && fileTypes.includes(file.type)) {
        if (file.size > maxFileSize) {
          setModalContent('File size is too large.');
          setModalLink('');
          toggleModal();
          return;
        }
        if (file.type !== 'application/msword') {
          reader.onloadend = () => {
          };
          reader.readAsDataURL(file);

          profileImageApi(file)
          if (pageType !== "Network") {
            const { setFieldValue } = props;
            setFieldValue(name, file)
          }
        } else {
          setModalContent(errorMsg);
          setModalLink('');
          toggleModal();
        }
      } else {
        setModalContent(errorMsg);
        setModalLink('');
        toggleModal();
      }
    }
  };

  const profileImageApi = async (profileImg) => {
    let formData = new FormData();
    formData.append('profileImage', profileImg);
    let response = await dispatch(profileImage(formData, token));
    if (response.status === 'SUCCESS') {
      setUserImage(profileImg);
      setModalContent(response.message);
      setModalLink('');
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  const [profileImageUrl, setProfileImage] = useState();
  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let imgResponse = '';
      if (profileImagePath) {
        imgResponse = await dispatch(imageShow(profileImagePath, token));
        setProfileImage(imgResponse)
      }

    }
  }, []);

  useEffect(() => {
    fetchMyAPI();
  }, [fetchMyAPI]);
  return (
    <>
      <Container className='picture-box-container'>
        <PictureBox className='picture-box'>
          {profileImageUrl || userImage ? (
            <img
              src={userImage ? URL.createObjectURL(userImage) : setProfilePic}
              alt=""
            />
          ) : <img
            src={userImage && profileImagePath ? URL.createObjectURL(userImage) : setProfilePic}
            alt=""
          />}
          <InputFile>
            <input
              onChange={onImageChange}
              acceptFiles="image/png,image/jpeg"
              errorMsg="File type must be .PNG, .JPG"
              multiple
              type="file"
              name="name"
              id="getFile"
            />
          </InputFile>
          {pageType !== "Network" && (
            <Upload onClick={getProfilePic}>
              <AddAPhotoOutlinedIcon className='photo-upload-icon' />
            </Upload>
          )}
        </PictureBox>
        <ProfileData>
          <h3>{ProfileName}</h3>
          <p>{CompanyName}</p>
        </ProfileData>
      </Container>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
}


export default ProfilePicture;

const Container = styled.div`
    text-align: center; 
`
const Upload = styled.div`
    flex: unset;
    position: absolute;
    right: 0;
    left: 0 ma;
    left: 0;
    margin: 0 auto;
    max-width: 110px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor:pointer;
    svg {
            font-size: 40px;
                color: #fff;
    background: #00000075;
    padding: 5px;
    border-radius: 50%;

    }
`
const InputFile = styled.div`
   display:none;
`
const PictureBox = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  margin: 15px auto;
  border: 2px solid white;
  border-radius: 50%;
  img {
    border-radius: 50%;
    overflow: hidden;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
const ProfileData = styled.div`
  h3 {
    font-size: 24px;
    font-family: "latobold";
    text-transform: capitalize;
    word-wrap:break-word;
  }
`;